/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertPromotionRequest
 */
export interface UpsertPromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertPromotionRequest
     */
    pointsExpense?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    discountType: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertPromotionRequest
     */
    discountAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    accumulated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    availableInShop: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertPromotionRequest
     */
    maxRedemptions?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertPromotionRequest
     */
    minExpense?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpsertPromotionRequest
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpsertPromotionRequest
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    internalDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    showPopup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    availableInPos: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    availableInAdmin: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpsertPromotionRequest
     */
    pickupType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertPromotionRequest
     */
    freeDelivery: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpsertPromotionRequest
     */
    timesPerPerson?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPromotionRequest
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPromotionRequest
     */
    products?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPromotionRequest
     */
    weekDays?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertPromotionRequest
     */
    locations?: Array<string>;
}

/**
 * Check if a given object implements the UpsertPromotionRequest interface.
 */
export function instanceOfUpsertPromotionRequest(value: object): value is UpsertPromotionRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('availableInShop' in value) || value['availableInShop'] === undefined) return false;
    if (!('showPopup' in value) || value['showPopup'] === undefined) return false;
    if (!('availableInPos' in value) || value['availableInPos'] === undefined) return false;
    if (!('availableInAdmin' in value) || value['availableInAdmin'] === undefined) return false;
    if (!('freeDelivery' in value) || value['freeDelivery'] === undefined) return false;
    return true;
}

export function UpsertPromotionRequestFromJSON(json: any): UpsertPromotionRequest {
    return UpsertPromotionRequestFromJSONTyped(json, false);
}

export function UpsertPromotionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertPromotionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'pointsExpense': json['pointsExpense'] == null ? undefined : json['pointsExpense'],
        'discountType': json['discountType'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'enabled': json['enabled'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'accumulated': json['accumulated'] == null ? undefined : json['accumulated'],
        'availableInShop': json['availableInShop'],
        'code': json['code'] == null ? undefined : json['code'],
        'maxRedemptions': json['maxRedemptions'] == null ? undefined : json['maxRedemptions'],
        'minExpense': json['minExpense'] == null ? undefined : json['minExpense'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'internalDescription': json['internalDescription'] == null ? undefined : json['internalDescription'],
        'showPopup': json['showPopup'],
        'availableInPos': json['availableInPos'],
        'availableInAdmin': json['availableInAdmin'],
        'pickupType': json['pickupType'] == null ? undefined : json['pickupType'],
        'freeDelivery': json['freeDelivery'],
        'timesPerPerson': json['timesPerPerson'] == null ? undefined : json['timesPerPerson'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'products': json['products'] == null ? undefined : json['products'],
        'weekDays': json['weekDays'] == null ? undefined : json['weekDays'],
        'locations': json['locations'] == null ? undefined : json['locations'],
    };
}

export function UpsertPromotionRequestToJSON(json: any): UpsertPromotionRequest {
    return UpsertPromotionRequestToJSONTyped(json, false);
}

export function UpsertPromotionRequestToJSONTyped(value?: UpsertPromotionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'name': value['name'],
        'description': value['description'],
        'pointsExpense': value['pointsExpense'],
        'discountType': value['discountType'],
        'discountAmount': value['discountAmount'],
        'enabled': value['enabled'],
        'allowRepeat': value['allowRepeat'],
        'accumulated': value['accumulated'],
        'availableInShop': value['availableInShop'],
        'code': value['code'],
        'maxRedemptions': value['maxRedemptions'],
        'minExpense': value['minExpense'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'internalDescription': value['internalDescription'],
        'showPopup': value['showPopup'],
        'availableInPos': value['availableInPos'],
        'availableInAdmin': value['availableInAdmin'],
        'pickupType': value['pickupType'],
        'freeDelivery': value['freeDelivery'],
        'timesPerPerson': value['timesPerPerson'],
        'categories': value['categories'],
        'products': value['products'],
        'weekDays': value['weekDays'],
        'locations': value['locations'],
    };
}

